module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_search_close-a44c459b89d00d6e062777ed7ae62df1.svg";